<app-user-dashboard [fullScreen]="true">
  <div class="bg-container">
    <div class="container">
      <div class="column-info fade-in-up-js">
        <h1 class="title fade-in fade-in-delay">{{'AutomatedSettlements.Title' | translate}}</h1>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-2">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'AutomatedSettlements.Subtitle1' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-3">
            {{'AutomatedSettlements.Text1Part1' | translate}} <strong style="font-weight:600">{{'AutomatedSettlements.Text1Part2' | translate}}.</strong>

          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-4">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'AutomatedSettlements.Subtitle2' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-5">
            {{'AutomatedSettlements.Text2Part1' | translate}} <strong style="font-weight:600">{{'AutomatedSettlements.Text2Part2' | translate}} </strong>{{'AutomatedSettlements.Text2Part3' | translate}}.
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-6">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'AutomatedSettlements.Subtitle3' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-8">
            {{'AutomatedSettlements.Text3Part1' | translate}} <strong style="font-weight:600">{{'AutomatedSettlements.Text3Part2' | translate}} </strong>{{'AutomatedSettlements.Text3Part3' | translate}}.
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-9">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'AutomatedSettlements.Subtitle4' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-10">
            {{'AutomatedSettlements.Text4Part1' | translate}} <strong style="font-weight:600">{{'AutomatedSettlements.Text4Part2' | translate}}.</strong>
          </p>
        </div>
      </div>

      <div class="column-img fade-in-left-js only-desktop">
        <figure class="figure-img">
          <img src="../../../../assets/img/to_do_fruzty/liquidaciones.png" style="width: 80%" alt="flag"/>
        </figure>
      </div>

      <div class="column-img fade-in-right-js only-mobile">
        <figure class="figure-img">
          <img src="../../../../assets/img/to_do_fruzty/liquidaciones.png" style="width: 80%" alt="flag"/>
        </figure>
      </div>

    </div>
  </div>

</app-user-dashboard>

<app-footer-home></app-footer-home>

